module.exports = __webpack_public_path__ + "37b5a83976319a7fd33e2cbe66a01576.svg";